import { render } from "./HomeRedirect.vue?vue&type=template&id=1f7ea196"
import script from "./HomeRedirect.vue?vue&type=script&lang=js"
export * from "./HomeRedirect.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__